
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import AlertModule from 'vux/src/plugins/alert/module'

let moment = require('moment')

export default {
name: 'user',
directives: {
TransferDom
},
data () {
return {
showToast: false,
showNameToast: false,
userInfo: {},
login_name: '',
newPass: '',
newPassAng: '',
showToastTips: false
}
},
mounted () {
this.getUserInfo()
},
methods: {
getUserInfo () {
this.userInfo = JSON.parse(localStorage.getItem('loginUser'))
console.log(this.userInfo)
},
getDate (date) {
return moment(date).format('YYYY/MM/DD')
},
showDialog () {
this.showToast = true
},
showNameDialog () {
this.showNameToast = true
},
cancleNameChange () {
this.login_name = ''
this.showNameToast = false
},
cancleChange () {
this.newPassAng = ''
this.showToast = false
},
sureChange () {
if (this.newPass === '' || this.newPassAng === '') {
AlertModule.show({
title: '提示',
content: '密码不能为空',
buttonText: '确定'
})
return
}
if (this.newPass === this.newPassAng) {
this.$axios.post('/shuian/public/mobile/trace/update', { 'password': this.newPass })
.then(res => {
this.newPass = ''
this.newPassAng = ''
this.showToastTips = true
this.showToast = false
})
.catch(error => {
console.log(error)
})
} else {
this.newPass = ''
this.newPassAng = ''
AlertModule.show({
title: '提示',
content: '两次输入的密码不一致',
buttonText: '确定'
})
}
},
sureNameChange () {
if (this.login_name === '') {
AlertModule.show({
title: '提示',
content: '用户名不能为空',
buttonText: '确定'
})
return false
} else {
this.$axios.post('/shuian/public/mobile/trace/update', { 'login_name': this.login_name })
.then(res => {
console.log(res)
if (res.data.code === 200) {
this.userInfo.login_name = this.login_name
this.showToastTips = true
this.showNameToast = false
localStorage.setItem('loginUser', JSON.stringify(this.userInfo))
} else {
AlertModule.show({
title: '提示',
content: res.data.codeInfo,
buttonText: '确定'
})
}
})
.catch(error => {
console.log(error)
})
}
},
loginout () {
this.$axios.get('/shuian/public/mobile/trace/logout')
.then(res => {
this.$router.push({ path: '/login' })
localStorage.removeItem('loginUser')
localStorage.removeItem('fenceList')
})
.catch(error => {
console.log(error)
})
}
},
components: { XDialog, Toast }
}
